export const bannerType = [
  {
    cat_id: 1,
    page: "Home Page Banner",
    items: [
      {
        cat_id: 1,
        name: "home_banner_1",
      },
      {
        cat_id: 1,
        name: "home_banner_2",
      },
      {
        cat_id: 1,
        name: "home_banner_3",
      },
      {
        cat_id: 1,
        name: "home_banner_4",
      },
      {
        cat_id: 1,
        name: "home_banner_5",
      },
      {
        cat_id: 1,
        name: "home_banner_6",
      },
    ],
  },
  {
    cat_id: 2,
    page: "Gym Category Banner",
    items: [
      {
        cat_id: 2,
        name: "gym_cat_banner_1",
      },
    ],
  },
  {
    cat_id: 3,
    page: "Gym Details Page",
    items: [
      {
        cat_id: 3,
        name: "gym_detail_banner_1",
      },
    ],
  },
  {
    cat_id: 4,
    page: "Activity Banner",
    items: [
      {
        cat_id: 4,
        name: "activity_banner_1",
      },
    ],
  },
  {
    cat_id: 5,
    page: "E-Gym Banner",
    items: [
      {
        cat_id: 5,
        name: "egym-banner_1",
      },
      {
        cat_id: 5,
        name: "egym_banner_2",
      },
      {
        cat_id: 5,
        name: "egym_banner_3",
      },
    ],
  },
  {
    cat_id: 6,
    page: "Trainee Details Banner ",
    items: [
      {
        cat_id: 6,
        name: "trainer_detail_banner_1",
      },
    ],
  },
  {
    cat_id: 7,
    page: "my schedule",
    items: [
      {
        cat_id: 7,
        name: "schedule_banner_1",
      },
    ],
  },
  {
    cat_id: 8,
    page: " Reward Banner",
    items: [
      {
        cat_id: 8,
        name: "coin_banner_1",
      },
    ],
  },
  {
    cat_id: 9,
    page: "My Schedule Banner",
    items: [
      {
        cat_id: 8,
        name: "schedule_banner_1",
      },
    ],
  },
  {
    cat_id: 10,
    page: "Recipe of the Day",
    link_type: "recipeDetailScreen",
    items: [
      {
        cat_id: 10,
        name: "recipe",
      },
    ],
  },
  {
    cat_id: 11,
    page: "Traier Profile banner (height 200px)",
    //link_type: 'trainer_profile_banner',
    items: [
      {
        cat_id: 11,
        name: "trainer_profile_banner",
      },
    ],
  },
  {
    cat_id: 12,
    page: "BMR/BMI/Body Fat Banners",
    //link_type: 'trainer_profile_banner',
    items: [
      {
        cat_id: 12,
        name: "cal_bmi_1",
      },
      {
        cat_id: 12,
        name: "cal_1",
      },
      {
        cat_id: 12,
        name: "cal_bmr_1",
      },
      {
        cat_id: 12,
        name: "cal_fat_1",
      },
    ],
  },
  {
    cat_id: 13,
    page: "Free Trial",
    items: [
      {
        cat_id: 13,
        name: "free_trial",
      },
    ],
  },
  {
    cat_id: 14,
    page: "Goal Info",
    items: [
      {
        cat_id: 14,
        name: "goal_info",
      },
    ],
  },
  {
    cat_id: 15,
    page: "Gym Plan",
    items: [
      {
        cat_id: 15,
        name: "gym_plan",
      },
    ],
  },
  {
    // pt_subscription_banner, regular_subscription_banner,goal_subscription_banner
    cat_id: 16,
    page: "Personal Training Subscription",
    items: [
      {
        cat_id: 16,
        name: "pt_subscription_banner",
      },
    ],
  },
  {
    // pt_subscription_banner, regular_subscription_banner,goal_subscription_banner
    cat_id: 17,
    page: "Regural Subscription",
    items: [
      {
        cat_id: 17,
        name: "regular_subscription_banner",
      },
    ],
  },
  {
    // pt_subscription_banner, regular_subscription_banner,goal_subscription_banner
    cat_id: 18,
    page: "Goal Focus Subscription",
    items: [
      {
        cat_id: 18,
        name: "goal_subscription_banner",
      },
    ],
  },
];

export const websiteBannerType = [
  {
    cat_id: 1,
    page: "Home Page Banner",
    items: [
      {
        cat_id: 1,
        name: "website_home_page_banner_1",
        dispaly_name: "Home Page Banner",
      },
    ],
  },
  {
    cat_id: 2,
    page: "Gym Listing",
    items: [
      {
        cat_id: 1,
        name: "website_gym_listing_banner_1",
        dispaly_name: "Gym Listing",
      },
    ],
  },
  {
    cat_id: 3,
    page: "Landing Pages",
    items: [
      {
        cat_id: 3,
        name: "website_recurring",
        dispaly_name: "Recurring",
      },
      {
        cat_id: 3,
        name: "website_one_day_membership",
        dispaly_name: "One Day Membership",
      },
    ],
  },
];

export const colorCodes = [
  { name: "Red", color_code: "red", hex_code: "#FF0000" },
  { name: "Black", color_code: "black", hex_code: "#000000" },
  { name: "White", color_code: "white", hex_code: "#FFFFFF" },
];

export const ctaType = [
  {
    cat_id: 1,
    name: "Navigate to Page",
    value: "url",
    is_custom: 0,
    items: [
      {
        page_name: "All Gyms",
        url: "https://wtfgyms.com/gyms",
      },
      {
        page_name: "Noida Gyms",
        url: "https://wtfgyms.com/gyms/best-gym-in-noida",
      },
      {
        page_name: "Delhi Gyms",
        url: "https://wtfgyms.com/gyms/best-gym-in-delhi",
      },
      {
        page_name: "Ghaziabad Gyms",
        url: "https://wtfgyms.com/gyms/best-gym-in-ghaziabad",
      },
      {
        page_name: "Greater Noida Gyms",
        url: "https://wtfgyms.com/gyms/best-gym-in-greater-noida",
      },
    ],
  },
  {
    cat_id: 2,
    is_custom: 0,
    name: "One Day Membership Form",
    value: "one_day_membership",

    items: [
      {
        page_name: "One Day Membership",
        url: "one day membership",
      },
    ],
  },
  {
    cat_id: 5,
    is_custom: 0,
    name: "Recurring Form",
    value: "recurring",

    items: [
      {
        page_name: "Recurring Form",
        url: "recurring form",
      },
    ],
  },
  {
    cat_id: 4,
    is_custom: 0,
    name: "Landing Pages",
    value: "url",

    items: [
      {
        page_name: "Recurring",
        url: "http://wtfgyms.com/lp/recurring_lp_sale",
      },
      {
        page_name: "One Day Membership",
        url: "https://wtfgyms.com/lp/Oneday_lp_sale",
      },
    ],
  },
  {
    cat_id: 3,
    is_custom: 1,
    name: "Custom",
    value: "url",

    items: [
      {
        page_name: "Custome URL",
        url: "",
      },
    ],
  },
];
